import initMenuHandling from './initHelper/initMenuHandling';

import exceptionHandler from './globalFunctions/exceptionHandler';
import tokenRefresher from './globalFunctions/tokenRefresher';
import applicationInsightsLoader from './globalFunctions/applicationInsightsLoader';
import registerGlobals from './globalFunctions/registerGlobals';
import $ from 'jquery';

window.$ = $;

/**
 * Init global functions
 */

// Auto-refresh JWT tokens when they expire
tokenRefresher();

// Setup Application Insights - C# calls window.initApplicationInsights()
applicationInsightsLoader();

// Catch JS errors and show popup
exceptionHandler();

// Setup SignalR callbacks for real-time notifications
registerGlobals();

/**
 * Init helper
 */
$(document).ready(function () {
    
    // Handles menu open/close actions in the legacy navbar
    initMenuHandling();
});
